import { Injectable, NgZone } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { AppService } from '../../app-service/logic/app.service';
import { CredentialsService } from '../../credentials/logic/credentials.service';
import { NavController } from '@ionic/angular';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { RemoteActionBuilderService } from '../../remote-action-builder/remote-action-builder.service';
import { LocationService } from '../../location/location.service';
import { EmployeeService } from '../../employee/logic/employee.service';
import { AppParameterService } from '../../app-parameter/logic/app-parameter.service';
import { DriverPassengerRemoteActionBuilder } from 'src/app/_model/remote-action/remote-action-builder/driver-passenger-identification-remote-action-builder/driver-passenger-identification-remoteaction-builder';
import { GenericRemoteActionBuilder } from 'src/app/_model/remote-action/remote-action-builder/remote-action-builder';
import { EventService } from '../../event/event.service';

@Injectable({
  providedIn: 'root',
})
export class DriverPassengerIdentificationActionHandler
  implements ActionHandler
{
  // Public Member
  public readonly name: ActionHandlerType = 'dpidentification';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private appService: AppService,
    private credentialsService: CredentialsService,
    private navigationController: NavController,
    private clientStateService: ClientStateService,
    private remoteActionBuilderService: RemoteActionBuilderService,
    private employeeService: EmployeeService,
    private locationService: LocationService,
    private appParameterService: AppParameterService,
    private eventService: EventService,
    private zone: NgZone
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    const initialData = {}

    switch (params?.type) {
      case "driver":
        initialData['dpflag'] = 'dpd';
        break;
      case "passenger":
        initialData['dpflag'] = 'dpp'
        break;
      case "privatetrip":
        initialData['dpflag'] = 'dpd';
        initialData['privatetrip'] = true
        break;
      default:
        break;
    }

    if (params?.passengercount) {
      initialData['passengercount'] = +params.passengerCount
    }

    const rab: GenericRemoteActionBuilder =
      new DriverPassengerRemoteActionBuilder(
        this.clientStateService,
        this.appService,
        this.credentialsService,
        this.employeeService,
        this.locationService,
        this.appParameterService,
        this.eventService,
        this.logger,
        initialData
      );
    this.remoteActionBuilderService.newBuild(rab);
    this.zone.run(() => {
      this.navigationController.navigateForward('/feature/remote-action');
    });
  }

  // Private Functions
}
